import { effect, inject, Injectable, signal } from '@angular/core';
import { MessageService } from '@shared/services/message.service';

@Injectable({ providedIn: 'root' })
export class ConnectionService {
  /**
   * Uses the browser's navigator to determine whether the user is currently online/offline.
   */
  public readonly isOnline = signal(true);

  private readonly messageService = inject(MessageService);

  constructor() {
    window.addEventListener('online', () => this.isOnline.set(true));
    window.addEventListener('offline', () => this.isOnline.set(false));

    effect(() => {
      const isOnline = this.isOnline();
      this.messageService.showConnectionStateChangeMessage(isOnline);
    });
  }
}
